module.exports = "/_next/static/images/coffee-388407d8575be41e276e084613bcc63b.png";